import React, { useState,useEffect } from "react";
import "./ShoppingCart.css";
import { useSelector, useDispatch } from "react-redux";
import Loogin from "../Authentication/Login/Login";
import { useAuth } from '../../Auth/AuthContext copy';
import AlertVerifyEmail from '../../Components/Verify/verify_alert';
import { doc,setDoc,serverTimestamp } from "firebase/firestore";
import { dbb } from "../../firebase/config";
import {clearCart} from "../../Features/Cart/cartSlice";
import { v4 as uuidv4 } from "uuid";
import {
  removeFromCart,
  updateQuantity,
  selectCartTotalAmount,
} from "../../Features/Cart/cartSlice";

import { MdOutlineClose } from "react-icons/md";

import { Link } from "react-router-dom";

import success from "../../Assets/success.png";

const ShoppingCart = () => {
  const cartItems = useSelector((state) => state.cart.items);
  const dispatch = useDispatch();
  const { currentUser, setModal } = useAuth();
  const openLogin = () => {
    setModal({ isOpen: true, title: 'Login', content: <Loogin /> });
  };
  const [activeTab, setActiveTab] = useState("cartTab1");
  const [isOrderPlaced, setIsOrderPlaced] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);

  const closeAlert = () => {
    setShowAlert(false);
  };
  useEffect(() => {
    console.log('calling useeffect');
    if (isOrderPlaced) {
      handleTabClick("cartTab3");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
  }, [isOrderPlaced]);
  const [canProceedToCheckout, setCanProceedToCheckout] = useState(false);

  const handleTabClick = (tab) => {
    console.log(`isOrderPlaced value ${isOrderPlaced}`);
    if (tab === "cartTab1") {
      setActiveTab("cartTab1");
    } else if (tab === "cartTab2" && canProceedToCheckout) {
      setActiveTab("cartTab2");
    } else if (tab === "cartTab3" && isOrderPlaced) {
      console.log('call this cart tab3');
      setActiveTab("cartTab3");
    }
  };
  const handleProceedToCheckout = () => {
    if (!currentUser) {
      openLogin();
    } else if (!currentUser.emailVerified) {
      setShowAlert(true);
    } else {
      setCanProceedToCheckout(true);
      setActiveTab("cartTab2");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };


  // const handleTabClick = (tab) => {
  //   if (tab === "cartTab1" || cartItems.length > 0) {
  //     setActiveTab(tab);
  //   }
  // };

  // const handleQuantityChange = (productId, quantity) => {
  //   if (quantity >= 1 && quantity <= 20) {
  //     dispatch(updateQuantity({ productID: productId, quantity: quantity }));
  //   }
  // };
  const handleQuantityChange = (product, newQuantity) => {
    if (newQuantity < 1 || newQuantity > 20) return;

    dispatch(updateQuantity({
      productID: product.productID,
      size: product.size || null,   // Ensure size is considered if it exists
      color: product.color || null, // Ensure color is considered if it exists
      quantity: newQuantity,
    }));
  };
  const totalPrice = useSelector(selectCartTotalAmount);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // current Date

  const currentDate = new Date();

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Random number

  const orderNumber = Math.floor(Math.random() * 100000);

  // Radio Button Data

  const [selectedPayment, setSelectedPayment] = useState(
    "Direct Bank Transfer"
  );

  const handlePaymentChange = (e) => {
    setSelectedPayment(e.target.value);
  };

  const [formData, setFormData] = useState({
    name: "",
    country: "Pakistan",
    city: "",
    address: "",
    phone: "",
    orderNotes: "",
    paymentMode: "Cash on delivery",
  });
  const [errors, setErrors] = useState({});
  

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    // Remove red border when user starts typing
    setErrors({ ...errors, [e.target.name]: false });
  };


  const handlePlaceOrder = async () => {
    
    const { name, country, city, address, phone, orderNotes, paymentMode } =
      formData;

    // Check required fields
    const newErrors = {};
    if (!name) newErrors.name = true;
    if (!country) newErrors.country = true;
    if (!city) newErrors.city = true;
    if (!address) newErrors.address = true;
    if (!phone) newErrors.phone = true;

    // If any errors, highlight fields in red and stop order placement
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const orderId = uuidv4();
    // Prepare order data
    const orderData = {
      productOrdered: cartItems.map((item) => ({
        productID: item.productID,
        productName: item.productName,
        productPrice: item.productPrice,
        quantity: item.quantity,
        frontImg: item.frontImg,
        review:false,
        ...(item.size && { size: item.size }),
        ...(item.color && { color: item.color }),
      })),
      totalPrice: totalPrice > 0 && totalPrice < 5000 ? totalPrice + 200 : totalPrice,
      orderedUserName: name,
      userId: currentUser.uid, // Replace with actual logged-in user ID
      country,
      city,
      address,
      phone,
      orderedNotes: orderNotes || "",
      paymentMode,
      orderedStatus: "Pending",
      id:orderId,
      createdAt: serverTimestamp(),
      
    };
    
    try {
      setLoading(true);
      const docRef = doc(dbb, "orders", orderId);
      await setDoc(docRef, orderData);
      setFormData({
        name: "",
        country: "Pakistan",
        city: "",
        address: "",
        phone: "",
        orderNotes: "",
        paymentMode: "Cash on delivery",
      });
      setOrderDetails({
        orderNumber: orderId,
        currentDate: new Date(),
        totalPrice: totalPrice > 0 && totalPrice < 5000 ? totalPrice + 200 : totalPrice,
        selectedPayment: paymentMode,
        orderedItems: cartItems,
      });
      dispatch(clearCart());
      setIsOrderPlaced(true);
    } catch (error) {
      console.error("Error adding order: ", error);
      alert("Error placing order. Try again.");
    }finally {
      setLoading(false); // Hide loader
    }

  };

  return (
    <div>
      {showAlert && <AlertVerifyEmail closeAlert={closeAlert} />}
      <div className="shoppingCartSection">
        <h2>Cart</h2>

        <div className="shoppingCartTabsContainer">
          <div className={`shoppingCartTabs ${activeTab}`}>
            <button
              className={activeTab === "cartTab1" ? "active" : ""}
              onClick={() => {
                handleTabClick("cartTab1");
              }}
            >
              <div className="shoppingCartTabsNumber">
                <h3>01</h3>
                <div className="shoppingCartTabsHeading">
                  <h3>Shopping Bag</h3>
                  <p>Manage Your Items List</p>
                </div>
              </div>
            </button>
            <button
              className={activeTab === "cartTab2" ? "active" : ""}
              onClick={() => {
                handleTabClick("cartTab2");
               
              }}
              disabled={cartItems.length === 0 || !canProceedToCheckout || isOrderPlaced}
            >
              <div className="shoppingCartTabsNumber">
                <h3>02</h3>
                <div className="shoppingCartTabsHeading">
                  <h3>Shipping and Checkout</h3>
                  <p>Checkout Your Items List</p>
                </div>
              </div>
            </button>
            <button
              className={activeTab === "cartTab3" ? "active" : ""}
              onClick={() => {
                handleTabClick("cartTab3");
              }}
              disabled={!isOrderPlaced}
            >
              <div className="shoppingCartTabsNumber">
                <h3>03</h3>
                <div className="shoppingCartTabsHeading">
                  <h3>Confirmation</h3>
                  <p>Review And Submit Your Order</p>
                </div>
              </div>
            </button>
          </div>
          <div className="shoppingCartTabsContent">
            {/* tab1 */}
            {activeTab === "cartTab1" && (
              <div className="shoppingBagSection">
                <div className="shoppingBagTableSection">
                  {/* For Desktop Devices */}
                  <table className="shoppingBagTable">
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th></th>
                        <th>Price</th>
                        <th>Quantity</th>
                        <th>Subtotal</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItems.length > 0 ? (
                        cartItems.map((item) => (
                          <tr key={item.productID}>
                            <td data-label="Product">
                              <div className="shoppingBagTableImg">
                                <Link to={`/product/${item.productID}`} onClick={scrollToTop}>
                                  <img src={item.frontImg} alt="" />
                                </Link>
                              </div>
                            </td>
                            <td data-label="">
                              <div className="shoppingBagTableProductDetail">
                                <Link to={`/product/${item.productID}`} onClick={scrollToTop}>
                                  <h4>{item.productName}</h4>
                                </Link>
                                {item.size && ` Size: ${item.size}`}
                                {item.color && ` Color: ${item.color}`}
                              </div>
                            </td>
                            <td
                              data-label="Price"
                              style={{ textAlign: "center" }}
                            >
                              Rs {item.productPrice}
                            </td>
                            <td data-label="Quantity">
                              <div className="ShoppingBagTableQuantity">
                                <button
                                  onClick={() =>
                                    handleQuantityChange(
                                      item,
                                      item.quantity - 1
                                    )
                                  }
                                >
                                  -
                                </button>
                                <input
                                  type="text"
                                  min="1"
                                  max="20"
                                  value={item.quantity}
                                  onChange={(e) =>
                                    handleQuantityChange(
                                      item.productID,
                                      parseInt(e.target.value)
                                    )
                                  }
                                />
                                <button
                                  onClick={() =>
                                    handleQuantityChange(
                                      item,
                                      item.quantity + 1
                                    )
                                  }
                                >
                                  +
                                </button>
                              </div>
                            </td>
                            <td data-label="Subtotal">
                              <p
                                style={{
                                  textAlign: "center",
                                  fontWeight: "500",
                                }}
                              >
                                Rs {item.quantity * item.productPrice}
                              </p>
                            </td>
                            <td data-label="">
                              <MdOutlineClose
                                onClick={() =>
                                  dispatch(removeFromCart({
                                    productID: item.productID,
                                    size: item.size || null,
                                    color: item.color || null
                                  }))
                                }
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6">
                            <div className="shoppingCartEmpty">
                              <span>Your cart is empty!</span>
                              <Link to="/shop" onClick={scrollToTop}>
                                <button>Shop Now</button>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot>
                      <th
                        colSpan="6"
                        className="shopCartFooter"
                        style={{
                          borderBottom: "none",
                          padding: "20px 0px",
                        }}
                      >
                        {/* {cartItems.length > 0 && (
                          <div className="shopCartFooterContainer">
                            <form>
                              <input
                                type="text"
                                placeholder="Coupon Code"
                              ></input>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                }}
                              >
                                Apply Coupon
                              </button>
                            </form>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                              className="shopCartFooterbutton"
                            >
                              Update Cart
                            </button>
                          </div>
                        )} */}
                      </th>
                    </tfoot>
                  </table>

                  {/* For Mobile devices */}

                  <div className="shoppingBagTableMobile">
                    {cartItems.length > 0 ? (
                      <>
                        {cartItems.map((item) => (
                          <div key={item.productID}>
                            <div className="shoppingBagTableMobileItems">
                              <div className="shoppingBagTableMobileItemsImg">
                                <Link to={`/product/${item.productID}`} onClick={scrollToTop}>
                                  <img src={item.frontImg} alt="" />
                                </Link>
                              </div>
                              <div className="shoppingBagTableMobileItemsDetail">
                                <div className="shoppingBagTableMobileItemsDetailMain">
                                  <Link to={`/product/${item.productID}`} onClick={scrollToTop}>
                                    <h4>{item.productName}</h4>
                                  </Link>
                                  {item.size && ` Size: ${item.size}`}
                                  {item.color && ` Color: ${item.color}`}

                                  <div className="shoppingBagTableMobileQuantity">
                                    <button
                                      onClick={() =>
                                        handleQuantityChange(
                                          item,
                                          item.quantity - 1
                                        )
                                      }
                                    >
                                      -
                                    </button>
                                    <input
                                      type="text"
                                      min="1"
                                      max="20"
                                      value={item.quantity}
                                      onChange={(e) =>
                                        handleQuantityChange(
                                          item,
                                          parseInt(e.target.value)
                                        )
                                      }
                                    />
                                    <button
                                      onClick={() =>
                                        handleQuantityChange(
                                          item,
                                          item.quantity + 1
                                        )
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                  <span>Rs {item.productPrice}</span>
                                </div>
                                <div className="shoppingBagTableMobileItemsDetailTotal">
                                  <MdOutlineClose
                                    size={20}
                                    onClick={() =>
                                      dispatch(removeFromCart({
                                        productID: item.productID,
                                        size: item.size || null,
                                        color: item.color || null
                                      }))
                                    }
                                  />
                                  <p>Rs {item.quantity * item.productPrice}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        {/* <div className="shopCartFooter">
                          <div className="shopCartFooterContainer">
                            <form>
                              <input
                                type="text"
                                placeholder="Coupon Code"
                              ></input>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                }}
                              >
                                Apply Coupon
                              </button>
                            </form>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                              className="shopCartFooterbutton"
                            >
                              Update Cart
                            </button>
                          </div>
                        </div> */}
                      </>
                    ) : (
                      <div className="shoppingCartEmpty">
                        <span>Your cart is empty!</span>
                        <Link to="/shop" onClick={scrollToTop}>
                          <button>Shop Now</button>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
                <div className="shoppingBagTotal">
                  <h3>Cart Totals</h3>
                  <table className="shoppingBagTotalTable">
                    <tbody>
                      <tr>
                        <th>Subtotal</th>
                        <td>Rs {totalPrice.toFixed(2)}</td>
                      </tr>
                      <tr>
                        <th>Shipping</th>
                        <td>
                          <div className="shoppingBagTotalTableCheck">
                            <p>Rs {totalPrice > 0 && totalPrice < 5000 ? 200 : 0}</p>
                            {/* <p>Shipping Cost..</p> */}
                            {/* <p
                              onClick={scrollToTop}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              CHANGE ADDRESS
                            </p> */}
                          </div>
                        </td>
                      </tr>
                      {/* <tr>
                        <th>VAT</th>
                        <td>${(totalPrice === 0 ? 0 : 11).toFixed(2)}</td>
                      </tr> */}
                      <tr>
                        <th>Total</th>
                        <td>
                          {/* Rs {(totalPrice === 0 ? 0 : totalPrice + 200).toFixed(2)} */}
                          Rs {(totalPrice > 0 && totalPrice < 5000 ? totalPrice + 200 : totalPrice).toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <button
                    onClick={() => {
                      // handleTabClick("cartTab2");
                      handleProceedToCheckout();
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    disabled={cartItems.length === 0}
                  >
                    Proceed to Checkout
                  </button>
                </div>
              </div>
            )}

            {/* tab2 */}
            {activeTab === "cartTab2" && (
              <div className="checkoutSection">
                <div className="checkoutDetailsSection">
                  <h4>Billing Details</h4>
                  <div className="checkoutDetailsForm">
                    <form>
                      <input
                        type="text"
                        name="name"
                        placeholder="Name*"
                        value={formData.name}
                        onChange={handleChange}
                        style={{ border: errors.name ? "2px solid red" : "1px solid #ccc" }}
                      />

                      <select
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        style={{ border: errors.country ? "2px solid red" : "1px solid #ccc" }}
                      >
                        <option value="" disabled>
                          Country / Region
                        </option>
                        <option value="Pakistan">Pakistan</option>
                        <option value="Canada">Canada</option>
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="United States">United States</option>
                        <option value="Turkey">Turkey</option>
                      </select>
                      <input
                        type="text"
                        name="city"
                        placeholder="Town / City *"
                        value={formData.city}
                        onChange={handleChange}
                        style={{ border: errors.city ? "2px solid red" : "1px solid #ccc" }}
                      />
                      <input
                        type="text"
                        name="address"
                        placeholder="Street Address*"
                        value={formData.address}
                        onChange={handleChange}
                        style={{ border: errors.address ? "2px solid red" : "1px solid #ccc" }}
                      />
                      <input
                        type="text"
                        name="phone"
                        placeholder="Phone *"
                        value={formData.phone}
                        onChange={handleChange}
                        style={{ border: errors.phone ? "2px solid red" : "1px solid #ccc" }}
                      />
                      <textarea
                        name="orderNotes"
                        cols={30}
                        rows={8}
                        placeholder="Order Notes (Optional)"
                        value={formData.orderNotes}
                        onChange={handleChange}
                      />
                    </form>
                  </div>
                </div>
                <div className="checkoutPaymentSection">
                  <div className="checkoutTotalContainer">
                    <h3>Your Order</h3>
                    <div className="checkoutItems">
                      <table>
                        <thead>
                          <tr>
                            <th>PRODUCTS</th>
                            <th>SUBTOTALS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cartItems.map((items) => (
                            <tr>
                              <td>
                                {items.productName} x {items.quantity}
                              </td>
                              <td>Rs.{items.productPrice * items.quantity}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="checkoutTotal">
                      <table>
                        <tbody>
                          <tr>
                            <th>Subtotal</th>
                            <td>Rs.{totalPrice.toFixed(2)}</td>
                          </tr>
                          <tr>
                            <th>Shipping</th>
                            <td>Rs.{totalPrice > 0 && totalPrice < 5000 ? 200 : 0}</td>
                          </tr>
                          {/* <tr>
                            <th>VAT</th>
                            <td>$11</td>
                          </tr> */}
                          <tr>
                            <th>Total</th>
                            <td>
                              Rs.{(totalPrice > 0 && totalPrice < 5000 ? totalPrice + 200 : totalPrice).toFixed(2)}
                              {/* {(totalPrice === 0 ? 0 : totalPrice + 200).toFixed(
                                2
                              )} */}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="checkoutPaymentContainer">
                    <label>
                      <input
                        type="radio"
                        name="payment"
                        value="Cash on delivery"
                        defaultChecked
                        onChange={handlePaymentChange}
                      />
                      <div className="checkoutPaymentMethod">
                        <span>Cash on delivery</span>
                        <p>
                          Pay for your order upon delivery. Our delivery agent will collect the payment
                          and provide a receipt. Please ensure someone is available to receive the order.
                        </p>
                      </div>
                    </label>

                    <div className="policyText">
                      Your personal data will be used to process your order,
                      support your experience throughout this website, and for
                      other purposes described in our{" "}
                      <Link to="/terms" onClick={scrollToTop}>
                        Privacy Policy
                      </Link>
                      .
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      handlePlaceOrder();
                      // setPayments(true);
                      // handleTabClick("cartTab3");
                      // window.scrollTo({ top: 0, behavior: "smooth" });
                      
                    }}
                    disabled={loading}
                  >
                    {loading ? <span className="loader"></span> : "Place Order"}
                  </button>
                </div>
              </div>
            )}

            {/* tab3 */}
            {activeTab === "cartTab3" && (
              <div className="orderCompleteSection">
                <div className="orderComplete">
                  <div className="orderCompleteMessage">
                    <div className="orderCompleteMessageImg">
                      <img src={success} alt="" />
                    </div>
                    <h3>Your order is completed!</h3>
                    <p>Thank you. Your order has been received.</p>
                  </div>
                  <div className="orderInfo">
                    <div className="orderInfoItem">
                      <p>Order Number</p>
                      <h4>{orderDetails.orderNumber.split("-")[0]}</h4>
                    </div>
                    <div className="orderInfoItem">
                      <p>Date</p>
                      <h4>{formatDate(currentDate)}</h4>
                    </div>
                    <div className="orderInfoItem">
                      <p>Total</p>
                      <h4>Rs.{orderDetails.totalPrice.toFixed(2)}</h4>
                    </div>
                    <div className="orderInfoItem">
                      <p>Payment Method</p>
                      <h4>{orderDetails.selectedPayment}</h4>
                    </div>
                  </div>
                  <div className="orderTotalContainer">
                    <h3>Order Details</h3>
                    <div className="orderItems">
                      <table>
                        <thead>
                          <tr>
                            <th>PRODUCTS</th>
                            <th>SUBTOTALS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderDetails.orderedItems.map((items) => (
                            <tr>
                              <td>
                                {items.productName} x {items.quantity}
                              </td>
                              <td>Rs.{items.productPrice * items.quantity}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="orderTotal">
                      <table>
                        <tbody>
                          <tr>
                            <th>Subtotal</th>
                            <td>Rs.{orderDetails.totalPrice > 0 && orderDetails.totalPrice < 5000 ? orderDetails.totalPrice-200: orderDetails.totalPrice}

                            </td>
                          </tr>
                          <tr>
                            <th>Shipping</th>
                            <td>Rs.{orderDetails.totalPrice > 0 && orderDetails.totalPrice < 5000 ? 200 : 0}</td>
                          </tr>
                          <tr>
                            <th>Total</th>
                            <td>
                              Rs.{(orderDetails.totalPrice).toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoppingCart;
